type LocationInfo = { id: string; name: string };

let locationMap = new Map<string, LocationInfo>();

export function setLocations(locations: LocationInfo[]) {
  locationMap = new Map(locations.map((l) => [l.id, l]));
}

export function getLocationName(id: string): string | null {
  return locationMap.get(id)?.name ?? null;
}
